export interface ItemsCompletion {
  itemsCount: number;
  completedItemsCount: number;
}

export const isCompleted = (completion: ItemsCompletion): boolean =>
  completion.itemsCount === completion.completedItemsCount;
export const completedItem = { itemsCount: 1, completedItemsCount: 1 };
export const notMandatoryItem = { itemsCount: 0, completedItemsCount: 0 };
export const unopenedItem = { itemsCount: 1, completedItemsCount: 0 };

export const itemsCompletionAddComplete = (itemsCompletion: ItemsCompletion): ItemsCompletion => {
  return {
    itemsCount: itemsCompletion.itemsCount + 1,
    completedItemsCount: itemsCompletion.completedItemsCount + 1,
  };
};

export const itemsCompletionAddIncomplete = (itemsCompletion: ItemsCompletion): ItemsCompletion => {
  return {
    itemsCount: itemsCompletion.itemsCount + 1,
    completedItemsCount: itemsCompletion.completedItemsCount,
  };
};
